import {
  setMeasurementVideos,
  addMeasurementVideo,
  removeMeasurementVideo,
  setMeasurementFullVideo,
} from "./slices/measurementSlice";

export const uploadMeasurementVideo =
  (
    apiInstance,
    formData,
    setLoading,
    userId,
    eventId,
    athleteId,
    type,
    setUploadProgress,
  ) =>
  async (dispatch) => {
    try {
      const response = await apiInstance.post(
        `/FilesStorage/measurement-video/${userId}`,
        formData,
        {
          timeout: 10 * 60 * 1000,
          headers: {
            "Content-Type": "multipart/form-data",
            Accept: "text/plain",
          },
          onUploadProgress: (progressEvent) => {
            const percentCompleted = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total,
            );
            if (typeof setUploadProgress === "function") {
              setUploadProgress(percentCompleted);
            }
          },
        },
      );
      if (response.status === 200) {
        const data = {
          eventId: parseInt(eventId),
          userId: parseInt(athleteId),
          measurementType: parseInt(type),
          videoUploadIds: [response.data.id],
        };
        const responseUpload = await apiInstance.post(
          "/MeasurementVideos/add",
          data,
          {
            headers: {
              "Content-Type": "application/json",
            },
          },
        );
        dispatch(addMeasurementVideo(responseUpload.data[0]));
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

export const getVideosByType =
  (apiInstance, measurementId, type, setLoading) => async (dispatch) => {
    try {
      const response = await apiInstance.get(
        `/MeasurementVideos/${measurementId}/${type}`,
      );
      dispatch(setMeasurementVideos(response.data));
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

export const resetVideosByType = (setLoadAll) => async (dispatch) => {
  dispatch(setMeasurementVideos([]));
  setLoadAll(2);
};

export const deleteMeasurementVideos =
  (apiInstance, measurementId, type, videoUploadIds, setLoading) =>
  async (dispatch) => {
    if (
      !measurementId ||
      !type ||
      !Array.isArray(videoUploadIds) ||
      videoUploadIds.length === 0
    ) {
      console.error("Error: Invalid parameters to delete videos.");
      return;
    }

    setLoading(true);
    try {
      const response = await apiInstance.put(
        `/MeasurementVideos/${measurementId}`,
        {
          athleteMeasurementId: parseInt(measurementId),
          measurementType: parseInt(type),
          videoUploadIds,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );

      if (response.status === 200) {
        dispatch(removeMeasurementVideo(videoUploadIds));
      } else {
        console.error("Error deleting videos. Status code:", response.status);
      }
    } catch (error) {
      console.error("Error deleting videos:", error);
    } finally {
      setLoading(false);
    }
  };

export const getMeasurementFullVideoAction =
  (apiInstance, measurementId) => async (dispatch) => {
    dispatch(setMeasurementFullVideo({}));
    dispatch(setMeasurementVideos([]));
    try {
      const response = await apiInstance.get(
        `combine/measurement/video/${measurementId}`,
      );
      if (response.status === 200) {
        if (response.data.length > 0) {
          const getSix = response.data.filter(
            (item) => item.measurementType === "Full",
          );
          if (getSix.length > 0) {
            dispatch(setMeasurementFullVideo(getSix[0]));
          }
          dispatch(setMeasurementVideos(response.data));
        }
      }
    } catch (error) {
      console.error(error);
    }
  };

export const ResetGetMeasurementFullVideoAction =
  (setLoading) => async (dispatch) => {
    dispatch(setMeasurementFullVideo({}));
    dispatch(setMeasurementVideos([]));
    setLoading(false);
  };

export const deleteMeasurementFullVideoAction =
  (apiInstance, measurementId, setLoading, type) => async (dispatch) => {
    if (type === 6) {
      dispatch(setMeasurementFullVideo({}));
    } else {
      dispatch(removeMeasurementVideo(measurementId));
    }
    try {
      await apiInstance.delete(
        `/FilesStorage/delete/measurement-video/${measurementId}`,
      );
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };
